import React, { CSSProperties, FC, ReactNode } from 'react'

import { CaretDownFill } from 'react-bootstrap-icons'

import { Dropdown, Option, OptionGroup } from '../Dropdown/Dropdown'

import { ConditionalWrapper } from '../ConditionalWrapper'
import { Logo } from '../Logo'

import { InputDescription } from '../InputDescription/InputDescription'

import ButtonGroup from '../ButtonGroup/ButtonGroup'

export interface SettingsButtonProps {
  onClick: (e?: any) => void
  label: string | ReactNode
  options?: OptionGroup[]
  asButtons?: boolean
  disabled?: boolean
  triggerIcon?: React.ReactNode
  helpText?: string
  icon?: ReactNode
  containerStyle?: CSSProperties
  mainButtonStyle?: CSSProperties
  optionsStyle?: CSSProperties
  btnRef?: React.LegacyRef<HTMLButtonElement | undefined>
}

export const SettingsButton: FC<SettingsButtonProps> = ({
  onClick,
  label,
  options,
  asButtons,
  disabled = false,
  triggerIcon = <CaretDownFill />,
  helpText,
  icon=<Logo/>,
  containerStyle={},
  mainButtonStyle={},
  optionsStyle={},
  btnRef=undefined
}) => (
  <ConditionalWrapper
    condition={typeof helpText !== 'undefined' || disabled}
    wrapper={(children) => <InputDescription helpText={disabled ? 'Enabled in Pollination CAD plugins.' : helpText}>{children}</InputDescription>}
  >
    <ButtonGroup
      disabled={disabled}
      wrapperProps={{
        style: {...containerStyle}
      }}
    >
      <button
        ref={btnRef}
        type='button'
        onClick={onClick}
        disabled={disabled}
        style={mainButtonStyle}
      >
        {icon}
        {label}
      </button>
      {options && options.length
      && <>{
        asButtons ?
          <>{
            options.reduce((p,c) => [...p, ...c.options], [] as Option[]).map((o: Option) => 
              <button 
                type='button'
                key={o.id}
                style={{
                  ...optionsStyle,
                  flex: 1,
                  boxShadow: !disabled && o.checked 
                    ? optionsStyle && optionsStyle['highlight']
                    ? `inset 0px 0px 9px 4px ${optionsStyle['highlight']}` 
                    : 'inset 0px 0px 9px 4px #096dd9'
                    : undefined
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  o.onSelect && o.onSelect(o)
                }}
              >
                {o.icon ?? o.label}
              </button>
            )
          }</>
          :
          <Dropdown
            trigger={(
              <button
                type='button'
              >
                {triggerIcon}
              </button>
            )}
            optionGroups={options}
            contentProps={{
              align: 'end',
              style: {
                fontSize: 'clamp(0.65rem, 8vw - 0.75rem, 0.85rem)',
              },
            }}
            disabled={disabled}
          />
      }</>  
      }
    </ButtonGroup>
  </ConditionalWrapper>
)

export default SettingsButton